import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";
import { PortfolioCreationManagement } from "./PortfolioCreations";

const PortfolioCreation = () => {
    return <>
    <AsideMenu>
        <UserGroupMenu destination="/portfolio-creation" />
    </AsideMenu>
    <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/portfolio-creation/:userGroup" permission={Permissions.ACCOUNTS} component={PortfolioCreationManagement} />
            </Switch>
        </Suspense>
    </Section>
</>
};

export default PortfolioCreation;
